import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getOnlineRegistration } from "../Service/Api";
import LazyLoad from "react-lazyload";

const OnlineRegistration = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      try {
        const registrationData = await getOnlineRegistration();
        setData(registrationData || []);
      } catch (error) {
        console.error("Error fetching registration data:", error);
      }
    };

    getData();
  }, []);

  return (
    <>
      <div className="OnlineR">
        {data && data.length > 0 && (
          <span className="bounce1">
            <Link
              to={data[0].url}
              target="_blank"
              className="parantlogo"
              rel="noopener noreferrer"
            >
              <LazyLoad>{data[0].title}</LazyLoad>
            </Link>

            {data[0].attachments && (
              <Link
                to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${
                  Array.isArray(data[0].attachments)
                    ? data[0].attachments[0]
                    : data[0].attachments
                }`}
                target="_blank"
                className="parantlogo-attachment"
                rel="noopener noreferrer"
              >
                <i className="bi bi-paperclip"></i>
              </Link>
            )}
          </span>
        )}
      </div>
    </>
  );
};

export default OnlineRegistration;
